export default /[A-Z&]/g;
